import React from 'react';
import {NavLink} from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu'

class Header extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            menuOpen: false,
        }
        
    }

    componentWillReceiveProps(nextProps) {
        window.scrollTo(0, 0);
        this.handleMenuClick();
    }

    handleMenuClick = (event) => {
        this.setState({menuOpen: false});
    }
    
    render(){
        return ( 
            <header className="site-nav-bar">
                
                <nav className="container">
                    <ul className="logo">
                        <li>
                            <NavLink to="/">
                                <img src="../images/logo-lg.png" className="hidden-xs hidden-sm visible-md visible-lg" />
                                <img src="../images/logo-sm.png" className="visible-xs visible-sm hidden-md hidden-lg" />
                            </NavLink>
                        </li>
                    </ul>

                    <ul className="nav desktop">                 
                        <li><NavLink to="/" exact={true}>Hjem</NavLink></li>
                        <li><NavLink to="/cycles">Cykler</NavLink></li>
                        <li><NavLink to="/accessories">Tilbehør</NavLink></li>
                        <li><NavLink to="/repairs">Værksted</NavLink></li>
                        <li><NavLink to="/rent-a-cycle">Cykeludlejning</NavLink></li>
                        <li><NavLink to="/about">Om Os</NavLink></li>
                        <li><NavLink to="/contact">Kontakt</NavLink></li>
                    </ul>
                </nav>

                <div className="hidden-lg hidden-md">
                <Menu right isOpen={ this.state.menuOpen } >
                    <ul className="nav mobile">                 
                        <li><NavLink to="/" exact={true}>Hjem</NavLink></li>
                        <li><NavLink to="/cycles">Cykler</NavLink></li>
                        <li><NavLink to="/accessories">Tilbehør</NavLink></li>
                        <li><NavLink to="/repairs">Værksted</NavLink></li>
                        <li><NavLink to="/rent-a-cycle">Cykeludlejning</NavLink></li>
                        <li><NavLink to="/about">Om Os</NavLink></li>
                        <li><NavLink to="/contact">Kontakt</NavLink></li>
                    </ul>
                </Menu>
                </div>
            </header>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Common/Header.js